export default angular.module('SecondaryFilterBar', []);

